import {Button} from "@mui/material";
import type {ButtonProps} from "@mui/material/Button";

const PrimaryButton = (props: ButtonProps) => {
    return (
        <Button
            variant="contained"
            {...props}
            sx={{
                textTransform: "none",
                "&:hover": {
                    backgroundColor: "primary.50",
                    color: "primary.main",
                },
                whiteSpace: "nowrap",
                px: 1,
                width: "100%",
                ...props.sx,
            }}
        >
            {props.children}
        </Button>
    );
};

export default PrimaryButton;
